import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { getLocale } from "../../config/i18n";

function Header({
  description,
  lang,
  meta,
  title,
  alternates,
  location,
  img = "/ld-schema-event-image.jpg",
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const locale = getLocale(lang);

  // TODO: Add lang as html element lang attribute https://github.com/gatsbyjs/gatsby/discussions/35841#discussioncomment-3357209
  return (
    <>
      <title>{`${title} | ${site.siteMetadata.title}`}</title>

      <meta name="description" content={metaDescription} />
      <meta property="og:locale" content={locale.ogLanguage} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`${site.siteMetadata.siteUrl}${location.pathname}`}
      />
      <meta
        property="og:image"
        content={`${site.siteMetadata.siteUrl}${img}`}
      />
      <meta name="twitter:card" content="summary" />
      <meta
        property="twitter:domain"
        content={`${site.siteMetadata.siteUrl.slice(8)}`}
      />
      <meta
        property="twitter:url"
        content={`${site.siteMetadata.siteUrl}${location.pathname}`}
      />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta
        property="twitter:image"
        content={`${site.siteMetadata.siteUrl}${img}`}
      />

      {meta.map(m => (
        <meta name={m.name} content={m.content} />
      ))}

      {alternates.map(a => (
        <link
          key={a.hrefLang}
          rel="alternate"
          href={a.href}
          hrefLang={a.hrefLang}
        />
      ))}
    </>
  );
}

Header.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  alternates: [],
};

Header.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  alternates: PropTypes.arrayOf(PropTypes.object),
};

export default Header;
